import ABTestSDK from '@wegic/abtest';
import { getUserId } from '@/helpers/userId';
import { useDebugStore } from '@/stores/debug';
import { useUserStore } from '@/stores/user';
/**
 * 拉取一次 AB 实验。
 * 优先从 store 读 userId，store 未 rehydrate 时降级从 localStorage 直接解析。
 * 生产环境或调试开关开启时同时启用火山客户端 SDK。
 */
export function reinitABTest() {
  const userId = getUserId();
  const enableClientABTest = useDebugStore.getState().enableClientABTest;
  const enableClientSDK = process.env.NODE_ENV === 'production' || enableClientABTest;

  return ABTestSDK.init({
    userId: userId || undefined,
    enableClientSDK,
  });
}

/** 启动 AB 实验：订阅 userId 变化，立即拉一次并在变化时重新拉取 */
export function initABTest() {
  let lastUserId = getUserId();
  reinitABTest();

  useUserStore.subscribe((state) => {
    const userId = state.userInfo?.userId;
    if (userId === lastUserId) {
      return;
    }
    lastUserId = userId;
    reinitABTest();
  });
}
